import { render, staticRenderFns } from "./language-list.vue?vue&type=template&id=9da14992"
import script from "./language-list.vue?vue&type=script&lang=ts"
export * from "./language-list.vue?vue&type=script&lang=ts"
import style0 from "./language-list.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports